// Дрібні спільні хуки.
import { useEffect, useState } from 'react';

/** Значення із затримкою (пошук у таблицях і комбобоксах). */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}

/** Стан у localStorage (лише зручності користувача: колонки таблиці, щільність). Помилки сховища ігноруються. */
export function useLocalStorageState<T>(key: string | undefined, initial: T): [T, (v: T) => void] {
  const [value, setValue] = useState<T>(() => {
    if (!key) return initial;
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? initial : (JSON.parse(raw) as T);
    } catch {
      return initial;
    }
  });
  const set = (v: T) => {
    setValue(v);
    if (!key) return;
    try {
      localStorage.setItem(key, JSON.stringify(v));
    } catch {
      /* ігноруємо */
    }
  };
  return [value, set];
}

/** Медіазапит (мобільна адаптація шелла). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
